module.exports = __webpack_public_path__ + "static/media/hz_tu2.6a68f569.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hz_tu2.jpg
// module id = 1588
// module chunks = 10